import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  message,
  Steps,
  Typography,
  Space,
  InputNumber,
  Tabs,
  Image,
  Layout,
  Table,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import "./styles.css";
import BackgroundImage from "../../Utils/styledBackgroundImage";
import actions from "../../redux/createteam/actions";
import config from "../../Services/apiEndPoints";
import { useSelector, useDispatch } from "react-redux";

const { Step } = Steps;
const { Title, Text } = Typography; // Correctly import Text
const { TabPane } = Tabs;
const { Header } = Layout;

const SchoolDetailsForm = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    schoolName: "",
    branchName: "",
    address: "",
    schoolPhoneNumber: "",
    schoolEmail: "",
  });
  const [contactPersons, setContactPersons] = useState([
    { name: "", mobileNumber: "", email: "" },
  ]);
  const [juniorForm] = Form.useForm();
  const [seniorForm] = Form.useForm();
  const [previewData, setPreviewData] = useState(null);
  const [activeTab, setActiveTab] = useState("junior");
  const [juniorTeamsCount, setJuniorTeamsCount] = useState(0);
  const [seniorTeamsCount, setSeniorTeamsCount] = useState(0);
  const [juniorTeams, setJuniorTeams] = useState([]);
  const [seniorTeams, setSeniorTeams] = useState([]);
  const [canProceedToPreview, setCanProceedToPreview] = useState(false);
  const [showTeamForm, setShowTeamForm] = useState({
    junior: false,
    senior: false,
  });
  const [currentTeam, setCurrentTeam] = useState({
    tab: "junior",
    index: null,
  });
  const [studentFormVisible, setStudentFormVisible] = useState(false);

  const [newStudent, setNewStudent] = useState({
    name: "",
    class: "",
    section: "",
    roll_number: "",
  });

  const [isSaveStudentButtonEnabled, setIsSaveStudentButtonEnabled] =
    useState(false);

  const [currentStudents, setCurrentStudents] = useState([]);
  const [isSaveTeamButtonEnabled, setIsSaveTeamButtonEnabled] = useState(false);

  const [teamName, setTeamName] = useState("");

  const steps = [
    {
      title: "School Details",
      description: "Enter school information.",
    },
    {
      title: "Team Details",
      description: "Enter team and student details.",
    },
    {
      title: "Preview",
      description: "Review and submit the data.",
    },
  ];

  // Add this effect to clear form data when switching tabs
  useEffect(() => {
    // Reset form data when switching tabs
    setTeamName("");
    setCurrentStudents([]);
    setStudentFormVisible(false);
    setShowTeamForm({
      junior: false,
      senior: false,
    });
  }, [activeTab]);

  const handleInputChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSchoolSubmit = () => {
    const payload = {
      school_name: formData?.schoolName,
      school_branch: formData?.branchName,
      email_id: formData?.schoolEmail,
      address:{address1: formData?.address},
      contact_details: [...contactPersons],
    };

    console.log(payload);
    // dispatch(actions.createSchool(config.schoolcreate, payload));
    setStep(1);
  };

  const handleContactChange = (index, field, value) => {
    const updatedContacts = [...contactPersons];
    updatedContacts[index][field] = value;
    setContactPersons(updatedContacts);
  };

  useEffect(() => {
    setCanProceedToPreview(
      4 > juniorTeamsCount >= 1 && 4 > seniorTeamsCount >= 1
    );
  }, [juniorTeamsCount, seniorTeamsCount]);

  const handleFinalSubmit = async () => {
    try {
      const juniorValues = await juniorForm.validateFields();
      const seniorValues = await seniorForm.validateFields();

      const dataToPreview = {
        ...formData,
        contactPersons: contactPersons,
        juniorTeams: juniorValues.teams || [],
        seniorTeams: seniorValues.teams || [],
      };

      setPreviewData(dataToPreview);
      setStep(2);
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
      message.error("Please correct the errors in the form.");
    }
  };




        // dispatch(actions.createStudent(config.studentcreate));
    // message.success("Final submission complete!");
  

  const handleAddTeam = (tab) => {
    if (
      (tab === "junior" && juniorTeams.length >= 3) ||
      (tab === "senior" && seniorTeams.length >= 3)
    ) {
      message.error("You can only add a maximum of 3 teams.");
      return;
    }

    setShowTeamForm({ ...showTeamForm, [tab]: true });
    setCurrentTeam({ tab, index: null });
    setCurrentStudents([]);
    setTeamName("");

    setIsSaveTeamButtonEnabled(false);
  };

  const handleTeamNameChange = (e) => {
    setTeamName(e.target.value);
  };

  const handleAddStudent = () => {
    setStudentFormVisible(true);
    setNewStudent({
      name: "",
      class: "",
      section: "",
      roll_number: "",
    });
  };

  const handleStudentChange = (field, value) => {
    setNewStudent({ ...newStudent, [field]: value });
    const updatedStudent = { ...newStudent, [field]: value };

    // Check if all required fields are filled
    const isComplete =
      updatedStudent.name !== "" &&
      updatedStudent.class !== "" &&
      updatedStudent.section !== "" &&
      updatedStudent.roll_number !== "";

    setIsSaveStudentButtonEnabled(isComplete);
  };

  const handleSaveStudent = () => {
    if (
      newStudent.name &&
      newStudent.class &&
      newStudent.section &&
      newStudent.roll_number
    ) {
      setCurrentStudents([...currentStudents, newStudent]);
      setNewStudent({ name: "", class: "", section: "", roll_number: "" });
      setStudentFormVisible(false);
      setIsSaveStudentButtonEnabled(false);
      message.success("Student Added Successfully");
    } else {
      message.error("Please fill in all student details");
    }
  };

  const handleDeleteStudent = (index) => {
    setCurrentStudents((prevStudents) => {
      const newStudents = [...prevStudents];
      newStudents.splice(index, 1);
      return newStudents;
    });
  };

  const handleSaveTeam = () => {
    if (!teamName) {
      message.error("Please Enter Team name");
      return;
    }

    if (currentStudents.length >= 1 && currentStudents.length <= 3) {
      // Use activeTab here instead of currentTeam.tab
      if (activeTab === "junior") {
        setJuniorTeams([
          ...juniorTeams,
          {
            teamName: teamName,
            team_type:'Junior',
            competition_type:"quiz",
            students: currentStudents,
          },
        ]);
        setJuniorTeamsCount(juniorTeamsCount + 1);
      } else {
        setSeniorTeams([
          ...seniorTeams,
          {
            teamName: teamName,
            team_type:'Senior',
            competition_type:"quiz",
            students: currentStudents,
          },
        ]);
        setSeniorTeamsCount(seniorTeamsCount + 1);
      }
      message.success("Team Saved Successfully");
      setShowTeamForm({ ...showTeamForm, [activeTab]: false });
      setTeamName("");
      setCurrentStudents([]);
      setIsSaveTeamButtonEnabled(false);
    } else {
      message.error("Team must have between 1 and 3 students.");
    }
  };

  const handleSubmit = () => {
    const payload = {
      student_data: [
        ...juniorTeams.flatMap(team =>
          team.students.map(student => ({
            ...student,
            team_name: team.teamName,
            team_type: team.team_type,
            competition_type:team.competition_type
          }))
        ),
        ...seniorTeams.flatMap(team =>
          team.students.map(student => ({
            ...student,
            team_name: team.teamName,
            team_type: team.team_type,
            competition_type:team.competition_type
          }))
        ),
      ],
    };
    console.log(payload);
  };


  useEffect(() => {
    if (currentStudents.length >= 1 && currentStudents.length <= 3) {
      setIsSaveTeamButtonEnabled(true);
    } else {
      setIsSaveTeamButtonEnabled(false);
    }
  }, [currentStudents]);

  const handleDeleteTeam = (tab, index) => {
    if (tab === "junior") {
      const newJuniorTeams = [...juniorTeams];
      newJuniorTeams.splice(index, 1);
      setJuniorTeams(newJuniorTeams);
      setJuniorTeamsCount(juniorTeamsCount - 1);
    } else {
      const newSeniorTeams = [...seniorTeams];
      newSeniorTeams.splice(index, 1);
      setSeniorTeams(newSeniorTeams);
      setSeniorTeamsCount(seniorTeamsCount - 1);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      className: "student-name-col",
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
      className: "student-class-col",
    },
    {
      title: "Section",
      dataIndex: "section",
      key: "section",
      className: "student-section-col",
    },
    {
      title: "Roll Number",
      dataIndex: "roll_number",
      key: "roll_number",
      className: "student-roll-col",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => (
        <Button danger onClick={() => handleDeleteStudent(index)}>
          Delete
        </Button>
      ),
    },
  ];

  const teamColumns = [
    {
      title: "Team Name",
      dataIndex: "teamName",
      key: "teamName",
    },
    {
      title: "Students",
      dataIndex: "students",
      key: "students",
      render: (students) => (
        <Row>
          {students.map((student, index) => (
            <Col key={index} span={24}>
              {student.name} class ({student.class})
            </Col>
          ))}
        </Row>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record, index) => (
        <Button danger onClick={() => handleDeleteTeam(activeTab, index)}>
          Delete
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div>
        <Header style={{ backgroundColor: "#ffb948", height: "75px" }}>
          <Row align="middle" gutter={16}>
            <Col
              xs={24}
              sm={6}
              md={6}
              lg={6}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <a
                href="https://sriramanavami.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Image
                    preview={false}
                    src="/favicon.ico"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </a>
            </Col>
          </Row>
        </Header>
      </div>
      <div className="enrollment-container">
        <Title level={2} className="page-title">
          School Enrollment Form
        </Title>

        <Steps current={step} className="enrollment-steps">
          {steps.map((item) => (
            <Step
              key={item.title}
              title={item.title}
              description={item.description}
            />
          ))}
        </Steps>
        {step === 0 && (
          <Card
            title="🏫 Enter School Details"
            bordered={false}
            style={{ borderRadius: "10px" }}
            className="form-card"
          >
            <Form layout="vertical" onFinish={handleSchoolSubmit}>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="School Name"
                    name="schoolName"
                    rules={[
                      { required: true, message: "Please enter school name" },
                    ]}
                    labelClassName="form-label"
                  >
                    <Input
                      placeholder="Enter school name"
                      value={formData.schoolName}
                      onChange={(e) =>
                        handleInputChange("schoolName", e.target.value)
                      }
                      className="form-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Branch Name"
                    name="branchName"
                    labelClassName="form-label"
                  >
                    <Input
                      placeholder="Enter branch name"
                      value={formData.branchName}
                      onChange={(e) =>
                        handleInputChange("branchName", e.target.value)
                      }
                      className="form-input"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="School Phone Number"
                    name="schoolPhoneNumber"
                    rules={[
                      {
                        required: true,
                        message: "Please enter school phone number",
                      },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Please enter a valid 10-digit mobile number",
                      },
                    ]}
                    labelClassName="form-label"
                  >
                    <Input
                      placeholder="Enter school phone number"
                      value={formData.schoolPhoneNumber}
                      onChange={(e) =>
                        handleInputChange("schoolPhoneNumber", e.target.value)
                      }
                      className="form-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="School Email"
                    name="schoolEmail"
                    rules={[
                      { required: true, message: "Please enter school email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                    labelClassName="form-label"
                  >
                    <Input
                      placeholder="Enter school email"
                      value={formData.schoolEmail}
                      onChange={(e) =>
                        handleInputChange("schoolEmail", e.target.value)
                      }
                      className="form-input"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    label="Address"
                    name="address"
                    rules={[
                      { required: true, message: "Please enter address" },
                    ]}
                    labelClassName="form-label"
                  >
                    <Input
                      placeholder="Enter address"
                      value={formData.address}
                      onChange={(e) =>
                        handleInputChange("address", e.target.value)
                      }
                      className="form-input"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Title level={5}>Contact Information</Title>
              {contactPersons.map((person, index) => (
                <div key={index} className="contact-person-card">
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        label="Contact Person Name"
                        rules={[
                          {
                            required: true,
                            message: "Please enter contact person name",
                          },
                        ]}
                        labelClassName="form-label"
                      >
                        <Input
                          placeholder="Enter contact person name"
                          onChange={(e) =>
                            handleContactChange(index, "name", e.target.value)
                          }
                          className="form-input"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Mobile Number"
                        rules={[
                          {
                            required: true,
                            message: "Please enter mobile number",
                          },
                          {
                            pattern: /^[0-9]{10}$/,
                            message:
                              "Please enter a valid 10-digit mobile number",
                          },
                        ]}
                        labelClassName="form-label"
                      >
                        <Input
                          placeholder="Enter mobile number"
                          onChange={(e) =>
                            handleContactChange(
                              index,
                              "mobileNumber",
                              e.target.value
                            )
                          }
                          className="form-input"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Email"
                        rules={[
                          {
                            type: "email",
                            message: "Please enter a valid email",
                          },
                        ]}
                        labelClassName="form-label"
                      >
                        <Input
                          placeholder="Enter email"
                          onChange={(e) =>
                            handleContactChange(index, "email", e.target.value)
                          }
                          className="form-input"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </div>
              ))}
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn-primary"
                >
                  Next
                </Button>
              </Form.Item>
            </Form>
          </Card>
        )}
        {step === 1 && (
          <Card
            title="Team and Student Details"
            bordered={false}
            className="form-card"
          >
            <Tabs
              activeKey={activeTab}
              onChange={setActiveTab}
              className="enrollment-tabs"
            >
              <TabPane tab="Junior Teams" key="junior">
                <Title level={4} className="team-title">
                  Junior Teams
                </Title>
                {!showTeamForm.junior && (
                  <Button
                    type="dashed"
                    onClick={() => handleAddTeam("junior")}
                    style={{ marginBottom: "20px" }}
                    disabled={juniorTeams.length >= 3} // max limit = 3
                  >
                    Add Team
                  </Button>
                )}
                {showTeamForm.junior && (
                  <Card
                    title={
                      <>
                        <Row align="middle" justify="space-between">
                          <Col>
                            <Text strong>Team Name :</Text>
                            <Input
                              placeholder="Enter Team Name"
                              style={{ width: 200, marginLeft: 10 }}
                              value={teamName}
                              onChange={handleTeamNameChange}
                            />
                          </Col>
                          <Col>
                            <Button
                              type="primary"
                              onClick={handleAddStudent}
                              disabled={
                                !teamName || currentStudents.length >= 3
                              } // Disable if team name is not entered OR if 3 students are there
                            >
                              Add Student
                            </Button>
                          </Col>
                        </Row>
                      </>
                    }
                    style={{ marginBottom: "20px" }}
                  >
                    {studentFormVisible && (
                      <div style={{ marginBottom: "20px" }}>
                        <Form layout="horizontal" onFinish={handleSaveStudent}>
                          <Row gutter={24}>
                            <Col span={12}>
                              <Form.Item
                                label="Student Name"
                                labelAlign="left"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter student name",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Student Name"
                                  value={newStudent.name}
                                  onChange={(e) =>
                                    handleStudentChange("name", e.target.value)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="Class"
                                labelAlign="left"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter student class",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Class"
                                  value={newStudent.class}
                                  onChange={(e) =>
                                    handleStudentChange("class", e.target.value)
                                  }
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={24}>
                            <Col span={12}>
                              <Form.Item
                                label="Section"
                                labelAlign="left"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter student section",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Section"
                                  value={newStudent.section}
                                  onChange={(e) =>
                                    handleStudentChange(
                                      "section",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="Roll Number"
                                labelAlign="left"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter student roll number",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Roll Number"
                                  value={newStudent.roll_number}
                                  onChange={(e) =>
                                    handleStudentChange(
                                      "roll_number",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={24} style={{ textAlign: "right" }}>
                              <Form.Item>
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  disabled={!isSaveStudentButtonEnabled}
                                >
                                  Save Student
                                </Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    )}
                    {currentStudents.length > 0 && (
                      <Table
                        columns={columns}
                        dataSource={currentStudents.map((student, index) => ({
                          key: index,
                          name: student.name,
                          class: student.class,
                          section: student.section,
                          roll_number: student.roll_number,
                        }))}
                        pagination={false}
                        className="student-table"
                      />
                    )}
                    <Button
                      type="primary"
                      onClick={handleSaveTeam}
                      disabled={!isSaveTeamButtonEnabled}
                    >
                      Save Team
                    </Button>
                  </Card>
                )}
                {juniorTeams.length > 0 && (
                  <div className="teams-container">
                    <Title level={5}>Junior Teams:</Title>

                    <Table
                      columns={teamColumns}
                      dataSource={juniorTeams.map((team, index) => ({
                        key: index,
                        teamName: team.teamName,
                        students: team.students,
                      }))}
                      className="teams-table"
                      bordered
                    />
                  </div>
                )}
              </TabPane>

              {/* Senior Teams Tab */}
              <TabPane tab="Senior Teams" key="senior">
                <Title level={4} className="team-title">
                  Senior Teams
                </Title>
                {!showTeamForm.senior && (
                  <Button
                    type="dashed"
                    onClick={() => handleAddTeam("senior")}
                    style={{ marginBottom: "20px" }}
                    disabled={seniorTeams.length >= 3}
                  >
                    Add Team
                  </Button>
                )}
                {showTeamForm.senior && (
                  <Card
                    title={
                      <>
                        <Row align="middle" justify="space-between">
                          <Col>
                            <Text strong>Team Name :</Text>
                            <Input
                              placeholder="Enter Team Name"
                              style={{ width: 200, marginLeft: 10 }}
                              value={teamName}
                              onChange={handleTeamNameChange}
                            />
                          </Col>
                          <Col>
                            <Button
                              type="primary"
                              onClick={handleAddStudent}
                              disabled={
                                !teamName || currentStudents.length >= 3
                              } // Disable if team name is not entered OR if 3 students are there
                            >
                              Add Student
                            </Button>
                          </Col>
                        </Row>
                      </>
                    }
                    style={{ marginBottom: "20px" }}
                  >
                    {studentFormVisible && (
                      <div style={{ marginBottom: "20px" }}>
                        <Form layout="horizontal" onFinish={handleSaveStudent}>
                          <Row gutter={24}>
                            <Col span={12}>
                              <Form.Item
                                label="Student Name"
                                labelAlign="left"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter student name",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Student Name"
                                  value={newStudent.name}
                                  onChange={(e) =>
                                    handleStudentChange("name", e.target.value)
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="Class"
                                labelAlign="left"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter student class",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Class"
                                  value={newStudent.class}
                                  onChange={(e) =>
                                    handleStudentChange("class", e.target.value)
                                  }
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={24}>
                            <Col span={12}>
                              <Form.Item
                                label="Section"
                                labelAlign="left"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter student section",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Section"
                                  value={newStudent.section}
                                  onChange={(e) =>
                                    handleStudentChange(
                                      "section",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={12}>
                              <Form.Item
                                label="Roll Number"
                                labelAlign="left"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter student roll number",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Roll Number"
                                  value={newStudent.roll_number}
                                  onChange={(e) =>
                                    handleStudentChange(
                                      "roll_number",
                                      e.target.value
                                    )
                                  }
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row>
                            <Col span={24} style={{ textAlign: "right" }}>
                              <Form.Item>
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  disabled={!isSaveStudentButtonEnabled}
                                >
                                  Save Student
                                </Button>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form>
                      </div>
                    )}
                    {currentStudents.length > 0 && (
                      <Table
                        columns={columns}
                        dataSource={currentStudents.map((student, index) => ({
                          key: index,
                          name: student.name,
                          class: student.class,
                          section: student.section,
                          roll_number: student.roll_number,
                        }))}
                        pagination={false}
                        className="student-table"
                      />
                    )}
                    <Button
                      type="primary"
                      onClick={handleSaveTeam}
                      disabled={!isSaveTeamButtonEnabled}
                    >
                      Save Team
                    </Button>
                  </Card>
                )}
                {seniorTeams.length > 0 && (
                  <div className="teams-container">
                    <Title level={5}>Senior Teams:</Title>

                    <Table
                      columns={teamColumns}
                      dataSource={seniorTeams.map((team, index) => ({
                        key: index,
                        teamName: team.teamName,
                        students: team.students,
                      }))}
                      className="teams-table"
                      bordered
                    />
                  </div>
                )}
              </TabPane>
            </Tabs>
            <Space
              style={{
                marginTop: "20px",
                justifyContent: "space-between",
                display: "flex",
              }}
            >
              <Button onClick={() => setStep(0)}>Previous</Button>
              <Button type="primary" onClick={handleFinalSubmit}>
                Next
              </Button>
            </Space>
          </Card>
        )}
        {step === 2 && (
          <Card
            title="🔍 Preview Your Submission"
            bordered={false}
            className="form-card"
          >
            {previewData && (
              <>
                {step === 2 && (
                  <Card bordered={false} className="form-card">
                    {previewData && (
                      <>
                        {/* <Title level={4}>School Information</Title>
                        <Table
                          dataSource={[
                            {
                              key: "1",
                              schoolName: previewData.schoolName,
                              branchName: previewData.branchName,
                              address: previewData.address,
                              phoneNumber: previewData.schoolPhoneNumber,
                              email: previewData.schoolEmail,
                            },
                          ]}
                          columns={[
                            {
                              title: "School Name",
                              dataIndex: "schoolName",
                              key: "schoolName",
                            },
                            {
                              title: "Branch Name",
                              dataIndex: "branchName",
                              key: "branchName",
                            },
                            {
                              title: "Address",
                              dataIndex: "address",
                              key: "address",
                            },
                            {
                              title: "Phone Number",
                              dataIndex: "phoneNumber",
                              key: "phoneNumber",
                            },
                            {
                              title: "Email",
                              dataIndex: "email",
                              key: "email",
                            },
                          ]}
                          pagination={false}
                          bordered
                          className="preview-table"
                          style={{ marginBottom: "30px" }}
                        />

                        <Title level={4}>Contact Persons</Title>

                        <Table
                          dataSource={previewData.contactPersons.map(
                            (contact, index) => ({
                              key: index,
                              name: contact.name,
                              mobileNumber: contact.mobileNumber,
                              email: contact.email,
                            })
                          )}
                          columns={[
                            { title: "Name", dataIndex: "name", key: "name" },
                            {
                              title: "Mobile Number",
                              dataIndex: "mobileNumber",
                              key: "mobileNumber",
                            },
                            {
                              title: "Email",
                              dataIndex: "email",
                              key: "email",
                            },
                          ]}
                          pagination={false}
                          bordered
                          className="preview-table"
                          style={{ marginBottom: "30px" }}
                        /> */}
                        {juniorTeams.length > 0 && (
                          <div>
                            <Title level={4}>Junior Teams</Title>
                            <Table
                           
                              dataSource={juniorTeams.map((team, index) => ({
                                key: index,
                                teamName: team.teamName,
                                students: team.students,
                              }))}
                              columns={[
                                {
                                  title: "Team Name",
                                  dataIndex: "teamName",
                                  key: "teamName",
                                },
                                {
                                  title: "Students",
                                  dataIndex: "students",
                                  key: "students",
                                  render: (students) => (
                                    <Table
                                      dataSource={students.map(
                                        (student, idx) => ({
                                          key: idx,
                                          name: student.name,
                                          class: student.class,
                                          section: student.section,
                                          roll_number: student.roll_number,
                                        })
                                      )}
                                      columns={[
                                        {
                                          title: "Name",
                                          dataIndex: "name",
                                          key: "name",
                                        },
                                        {
                                          title: "Class",
                                          dataIndex: "class",
                                          key: "class",
                                        },
                                        {
                                          title: "Section",
                                          dataIndex: "section",
                                          key: "section",
                                        },
                                        {
                                          title: "Roll Number",
                                          dataIndex: "roll_number",
                                          key: "roll_number",
                                        },
                                      ]}
                                      pagination={false}
                                      bordered
                                      size="small"
                                    />
                                  ),
                                },
                              ]}
                              pagination={false}
                              bordered
                               className="custom-table"
                              style={{ marginBottom: "30px" }}
                            />
                          </div>
                        )}
                        {seniorTeams.length > 0 && (
                          <div>
                            <Title level={4}>Senior Teams</Title>
                            <Table
                              dataSource={seniorTeams.map((team, index) => ({
                                key: index,
                                teamName: team.teamName,
                                students: team.students,
                              }))}
                              columns={[
                                {
                                  title: "Team Name",
                                  dataIndex: "teamName",
                                  key: "teamName",
                                },
                                {
                                  title: "Students",
                                  dataIndex: "students",
                                  key: "students",
                                  render: (students) => (
                                    <Table
                                      dataSource={students.map(
                                        (student, idx) => ({
                                          key: idx,
                                          name: student.name,
                                          class: student.class,
                                          section: student.section,
                                          roll_number: student.roll_number,
                                        })
                                      )}
                                      columns={[
                                        {
                                          title: "Name",
                                          dataIndex: "name",
                                          key: "name",
                                        },
                                        {
                                          title: "Class",
                                          dataIndex: "class",
                                          key: "class",
                                        },
                                        {
                                          title: "Section",
                                          dataIndex: "section",
                                          key: "section",
                                        },
                                        {
                                          title: "Roll Number",
                                          dataIndex: "roll_number",
                                          key: "roll_number",
                                        },
                                      ]}
                                      pagination={false}
                                      bordered
                                      size="small"
                                    />
                                  ),
                                },
                              ]}
                              pagination={false}
                              bordered
                              className="preview-table"
                              style={{ marginBottom: "30px" }}
                            />
                          </div>
                        )}
                        <Row
                          justify="space-between"
                          style={{ marginTop: "20px" }}
                        >
                          <Button
                            style={{ width: "40%" }}
                            onClick={() => setStep(1)}
                          >
                            Previous
                          </Button>
                          <Button
                            type="primary"
                            onClick={handleSubmit}
                            className="btn-primary"
                            style={{ marginTop: "10px", width: "40%" }}
                          >
                            Submit
                          </Button>
                        </Row>
                      </>
                    )}
                  </Card>
                )}
              </>
            )}
          </Card>
        )}
      </div>
    </div>
  );
};

export default SchoolDetailsForm;
